module.exports = __webpack_public_path__ + "assets/img/userAvatar.60a45445.svg";